import React, {useCallback, useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import LoadingIndicator from '../../../ReservationConfiguration/LoadingIcon'
import ItemRow from './ItemRow'
import _ from 'lodash'
import clsx from 'clsx'
import useGetAdvanceOptionRangeReducer from '../../../../state/calendar-views/get-shareable-advance-options/reducer'
import {getAdvanceOptionRange} from '../../../../state/calendar-views/get-shareable-advance-options/actions'
import {PopAdvOpt} from './PopAdvOpt'

export const DatesToDisplay = ({
  entity_id,
  groups,
  actions,
  disabledActions = [],
  disabledGroups = [],
  group,
  handleToggleActions,
  handleToggleGroup,
  handleSetActionAdvOpt,
}) => {
  const [advanceOptionRange, advanceOptionRangeDispatch] = useGetAdvanceOptionRangeReducer()
  const {t} = useTranslation()
  const [tab, setTab] = useState(0)
  const [cacheActionAdvancedOption, setCacheActionAdvancedOptions] = useState({}) // {<action_id>: data}
  const [advOptMeta, setAdvOptMeta] = useState({})

  const handleClickAdvOpt = (e, index, action) => {
    const t = e.target
    setAdvOptMeta({
      toggle: true,
      targetEl: t,
      axn_index: index,
      options: cacheActionAdvancedOption[action.action_id],
    })
  }

  const handleCloseAdvOpt = () => {
    setAdvOptMeta(p => ({toggle: false}))
  }

  // trigger load when actions changed
  useEffect(() => {
    if (group.isLoading) return

    const enabledActions = actions.filter(x => x.active === true)

    if (enabledActions.length === 0) return

    // !magic!
    setCacheActionAdvancedOptions(p => {
      let _cache = {...p}
      enabledActions.forEach(async (e, i) => {
        if (!e.action_id) return
        if (_cache[e.action_id]) return

        try {
          const dataList = await getAdvanceOptionRange(advanceOptionRangeDispatch, e.action_id)
          let arr = dataList?.fields ? dataList?.fields : []
          setCacheActionAdvancedOptions(pp => ({...pp, [e.action_id]: arr})) // pp will be up to date so no destructive overwriting
        } catch (error) {
          // api should try to return an empty field instead of 422 error
          setCacheActionAdvancedOptions(pp => ({...pp, [e.action_id]: []})) // pp will be up to date so no destructive overwriting
        }
      })

      return p // return p so no mutation will happen thus no rerender
    })
  }, [group, actions, advanceOptionRangeDispatch])

  return (
    <div
      className={clsx('ds-mt-24 ds-flex-col ds-flex-no-spill', {'ds-disabled': entity_id === -1})}
    >
      <div>
        <div className={`ds-t080b ds-required ds-mb-8`}>
          {t('calendar.view.add.display-dates.label')}
        </div>
        <div className={`ds-t060r`}>{t('calendar.view.add.display-dates.description')}</div>
      </div>
      <div className="ds-mt-12 ds-flex-col ds-flex-no-spill" hidden={entity_id === -1}>
        <div className="ds-tab-bar ds-tab--stretch ds-tab--underlined">
          <div
            onClick={e => setTab(0)}
            className={clsx('ds-tab-item', {'ds-tab-item--selected': tab === 0})}
          >
            {t('calendar.view.add.display-dates.tab-groups')}
          </div>
          <div
            onClick={e => setTab(1)}
            className={clsx('ds-tab-item', {'ds-tab-item--selected': tab === 1})}
          >
            {t('calendar.view.add.display-dates.tab-actions')}
          </div>
        </div>

        <div
          className="ds-flex-col ds-flex-no-spill ds-scrollbar ds-mt-4"
          style={{overflow: 'auto', gap: 4}}
          hidden={tab !== 0}
        >
          {group.isLoading && <LoadingIndicator />}
          {groups.length === 0 && !group.isLoading && (
            <span className={`ds-t060r ds-tg700`}>
              {t('calendar.view.add.display-dates.no-groups')}
            </span>
          )}
          {!group.isLoading &&
            _.map(groups || [], (g, gi) => (
              <ItemRow
                disabled={disabledGroups.indexOf(g.field_id) !== -1}
                key={g.field_id}
                data={(group.data.fields || []).find(f => f.id === g.field_id) || {}}
                checked={g.active}
                onChange={(e, v) => handleToggleGroup(e, gi, v)}
              />
            ))}
        </div>
        <div
          className="ds-flex-col ds-flex-no-spill ds-scrollbar ds-mt-4"
          style={{overflow: 'auto', gap: 4}}
          hidden={tab !== 1}
        >
          {group.isLoading && <LoadingIndicator />}
          {actions.length === 0 && !group.isLoading && (
            <span className={`ds-t060r ds-tg700`}>
              {t('calendar.view.add.display-dates.no-actions')}
            </span>
          )}
          {!group.isLoading &&
            _.map(actions || [], (g, gi) => (
              <ItemRow
                key={g.action_id}
                disabled={disabledActions.indexOf(g.action_id) !== -1}
                data={(group.data.actions || []).find(a => a.id === g.action_id) || {}}
                showAdvOpt={!!cacheActionAdvancedOption[g.action_id]?.length}
                checked={g.active}
                onChange={(e, v) => handleToggleActions(e, gi, v)}
                onClickAdvOpt={e => handleClickAdvOpt(e, gi, g)}
              />
            ))}
          <PopAdvOpt
            toggle={advOptMeta.toggle}
            onClose={handleCloseAdvOpt}
            advance_option_key={actions[advOptMeta.axn_index]?.advance_option_key}
            options={advOptMeta.options}
            targetEl={advOptMeta.targetEl}
            onChange={(e, v) => handleSetActionAdvOpt(e, advOptMeta.axn_index, v)}
          />
        </div>
      </div>
    </div>
  )
}
